import React from "react";

const NotificationSent = () => {
  return (
    <div className="p-2">
      <div className="p-3 bg-white rounded border">
        <p><strong>Date:</strong> [DD/MM/YYYY]</p>
        <p><strong>Subject:</strong> Notice for Society Meeting at 6:00 PM</p>
        <p>Dear Residents,</p>
        <p>This is to inform all members of [Society Name] that a society meeting has been scheduled as per the details below:</p>
        <ul>
          <li><strong>Date:</strong> [Insert Date]</li>
          <li><strong>Time:</strong> 6:00 PM</li>
          <li><strong>Venue:</strong> [Clubhouse / Society Hall / Common Area]</li>
        </ul>
        <p>The agenda includes important discussions regarding [mention briefly—e.g., maintenance, security, upcoming events, etc.].</p>
        <p>Your presence is highly appreciated, as your participation is important for collective decision-making.</p>
        <p>Thank you for your cooperation.</p>
        <p>Warm regards,</p>
        <p>[Secretary / Chairman]<br/>[Society Name]<br/>[Contact Details]</p>

        <div className="d-flex justify-content-end mt-3 gap-2">
          <button className="btn btn-outline-primary">Select</button>
          <button className="btn btn-primary">Send</button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSent;
